import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "./ui/sheet";

/**
 * The bottom sheet both Settings sheets share (#1135, I7): the Radix dialog
 * primitive already in the repo (`ui/sheet`), so an open sheet is
 * `role="dialog"` and journey 60 judges it on its own choices (Q-C2, D228).
 * The kit surface, no shadow, a 44px close control.
 */
export default function SettingsSheet({ open, onOpenChange, title, description, "data-testid": testId, children }) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="bottom"
        data-testid={testId}
        closeClassName="right-2 top-2 flex h-11 w-11 items-center justify-center opacity-100"
        style={{
          background: "var(--nw-surface)",
          boxShadow: "none",
          padding: "20px 20px 24px",
          maxHeight: "92vh",
          overflowY: "auto",
          maxWidth: 520,
          marginLeft: "auto",
          marginRight: "auto",
          borderTopLeftRadius: "var(--nw-radius-card)",
          borderTopRightRadius: "var(--nw-radius-card)",
        }}
      >
        <SheetHeader style={{ textAlign: "left", paddingRight: 44 }}>
          <SheetTitle style={{ fontFamily: "'Manrope', sans-serif", fontWeight: 800, fontSize: 18, color: "var(--nw-ink)" }}>
            {title}
          </SheetTitle>
          {description ? (
            <SheetDescription style={{ fontSize: 13, color: "var(--nw-ink-muted)" }}>{description}</SheetDescription>
          ) : (
            <SheetDescription className="sr-only">{title}</SheetDescription>
          )}
        </SheetHeader>
        <div style={{ display: "flex", flexDirection: "column", gap: 10, marginTop: 14 }}>{children}</div>
      </SheetContent>
    </Sheet>
  );
}
